var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.containerClass},[(_vm.icon)?_c('span',{class:_vm.iconClass}):_vm._e(),_vm._t("default",[_c('span',{staticClass:"p-tag-value"},[_vm._v(_vm._s(_vm.value))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }